/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Contact } from '../models/contact';
import { getContact } from '../fn/file-contact-controller/get-contact';
import { GetContact$Params } from '../fn/file-contact-controller/get-contact';

@Injectable({ providedIn: 'root' })
export class FileContactControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `fileContactControllerGetContact()` */
  static readonly FileContactControllerGetContactPath = '/files/{id}/contact';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContact$Response(params: GetContact$Params, context?: HttpContext): Observable<StrictHttpResponse<Contact>> {
    return getContact(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContact(params: GetContact$Params, context?: HttpContext): Observable<Contact> {
    return this.getContact$Response(params, context).pipe(
      map((r: StrictHttpResponse<Contact>): Contact => r.body)
    );
  }

}
